const routes = {
    GetRoles:'/artboards/roles',
    CreateRole:"/artboards/roles/add",
    UpdateRole:'/artboards/roles/update',
    DeleteRole:'/artboards/roles/delete'

  };
  
  export default routes